export default __webpack_public_path__ + "static/pepe-bae637621e88e48e2517ac92857a6891.webp";